import BaseCrudService from "./baseCrud.service";

export default class VolunteeringAttributeOfferService extends BaseCrudService {

    constructor() {
        super('VolunteeringAttributeOffer');
    }

    findById(id) {
        return this.getRequest(`FindById/${id}`);
    }

    /**
     * Vagas de um voluntariado.
     *
     * onlyActiveOffers default true: o endpoint é anônimo e alimenta o "Saiba mais"
     * da campanha, então quem esquecer o parâmetro recebe só as vagas ligadas. As
     * telas de cadastro passam false, porque o gestor precisa enxergar a vaga
     * desativada para conseguir religar.
     */
    findByVolunteeringId(volunteeringId, getOnlyActiveDates = true, onlyActiveOffers = true) {
        return this.getRequest(`FindByVolunteeringId/${volunteeringId}?getOnlyActiveDates=${getOnlyActiveDates}&onlyActiveOffers=${onlyActiveOffers}`);
    }

    listAll() {
        return this.getRequest('ListAll');
    }

    save(volunteeringAttributeOffer) {
        return this.postRequest('Save', volunteeringAttributeOffer);
    }

    delete(id) {
        return this.deleteRequest(`Delete/${id}`);
    }

    deleteVolunteeringPontualType(id) {
        return this.deleteRequest(`DeleteVolunteeringPontualType/${id}`);
    }

    deleteVolunteeringRecurrentType(id) {
        return this.deleteRequest(`DeleteVolunteeringRecurrentType/${id}`);
    }
    listVolunteeringAttributeOfferByCampaign(){
        return this.getRequest(`ListVolunteeringAttributeOfferByCampaign`);
    }

    listVolunteeringAttributeOfferByCompanyId(CompanyId){
        return this.getRequest(`ListVolunteeringAttributeOfferByCompanyId/${CompanyId}`);
    }
}